/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 15:55:51
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-19 16:02:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/GeneralCollapseHeader/index.tsx
 */
import React from 'react';

import css from './css.less';

import { InfoCircleFilled } from '@ant-design/icons';
import Dots from 'src/constrains/DotsMenuDrop';
import { Icon } from '@/src/tools/icon';

const GeneralCollapseHeader = (props) => {
  const {
    className,
    content,
    err,
    hasDots,
    dotsFunction = [],
    containerProps,
    onClick,
    hasArrow,
    arrowClassName,
    containerStyle,
  } = props;
  return (
    <div
      onClick={onClick}
      className={`${css.container} ${className || ''}`}
      style={containerStyle || {}}
      {...(containerProps || {})}>
      <div className={css.content}>{content}</div>
      {err && <InfoCircleFilled rev className={css.iconWarn} />}
      {hasDots && (
        <div className={css.dots}>
          <Dots options={dotsFunction} />
        </div>
      )}
      {hasArrow && <Icon type='iconback' className={arrowClassName} />}
    </div>
  );
};
export default GeneralCollapseHeader;
